import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";

import Consts from "../../utilities/Consts";
import CommonHelper from "../../utilities/CommonHelper";
import * as NetworkHelper from "../../utilities/Networkhelper";
import DropDownHelper from "../../utilities/DropDownHelper";
import { useFormik } from "formik";
import { Panel } from "primereact/panel";
import { BlockUI } from "primereact/blockui";
import { LkDropDown } from "../../components/LkDropDown";
import { LkInputTextarea } from "../../components/LkInputTextarea";
import { Toolbar } from "primereact/toolbar";
import StringHelper from "../../utilities/StringHelper";

export const SiparisIptal = (props) => {
  const { sip_id, iptal_tar ,is_fatura} = props;
  const cLabels = Consts.localizedStrings;
  const baseUrl = Consts.network.siparisler;

  const ref_FaturaSiparisAdres = useRef(undefined);
  const [errors, setErrors] = useState({});
  const [dd_sys_fat_iptal, set_dd_sys_fat_iptal] = useState([]);
  const [formData, setFormData] = useState({});
  const [blocked, setBlocked] = useState(false);
  const isFirstRender = useRef(true);

  const formik = useFormik({
    initialValues: {
      id: undefined,
      sd_iptal_tar: undefined,
      f_ip_neden_type: undefined,
      f_ip_neden: undefined,
      f_ip_aciklama: undefined,
    },

    validateOnChange: false,
    validateOnBlur: true,
    validate: (data) => {
      console.log(ref_FaturaSiparisAdres);
      let errors = {};
      if (!data.f_ip_neden_type) {
        errors.f_ip_neden_type = cLabels.requiredField;
      }
      // if (StringHelper.isEmpty(data.f_ip_aciklama)) {
      //   errors.f_ip_aciklama = cLabels.requiredField;
      // }
      setErrors(errors);
      if (Object.keys(errors).length !== 0) {
        CommonHelper.showWarnMessage(cLabels.lutfen_girdiginiz_bigileri_kontrol_ediniz);
      }

      return errors;
    },
    onSubmit: (data) => {
      setFormData(data);
      data.sd_cancel_on = "1";
      if (StringHelper.isNotEmpty(iptal_tar)) {
        data.sd_iptal_tar = iptal_tar;
      } else {
        data.sd_iptal_tar = CommonHelper.getCurrentDateTimeYYYYMMDDHHMM();
      }
      _update(data);
      
    },
  });
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      init();
    }
  });
  const init = async () => {
    setBlocked(true);
    let xxxx = CommonHelper.getCurrentDateTimeYYYYMMDDHHMM();
    console.log(xxxx);
    await Promise.all([
      set_dd_sys_fat_iptal(await DropDownHelper.sys_fat_iptal()),
      _getSiparis(),
    ]).then((values) => {
      setBlocked(false);
      
    });

  };
  const _getSiparis = async () => {
    
    try {
      let resp = await NetworkHelper.call_web_service(baseUrl.get, {
        id: sip_id,
      });
      let sip = resp.item;
      formik.setValues(sip);
    } catch (error) {
      console.log(error);
      CommonHelper.handleCatch(error);
    } finally {
    }
  }; //=>end

  const _update = async (_formData = formData) => {
    
    try {
      setBlocked(true);
      console.log("#### _formData", JSON.stringify(_formData))
      let resp = await NetworkHelper.call_web_service(is_fatura ? baseUrl.fatura_iptali:baseUrl.siparis_iptali, {
        id: _formData.id,
        f_ip_neden_type: _formData.f_ip_neden_type,
        f_ip_neden: _formData.f_ip_neden,
        sd_iptal_tar: _formData.sd_iptal_tar,
        f_ip_aciklama: _formData.f_ip_aciklama
      });
      
      CommonHelper.showSuccessMessage();
      props.onCloseSidebar(resp.save_response);
    } catch (error) {
      console.log(error);
      CommonHelper.handleCatch(error);
    } finally {
      setBlocked(false);
    }
  }; //=>end _update 
  const template = (options) => {
    const className = `${options.className} p-jc-start`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className={className}>
        <span className={titleClassName}>{is_fatura ? cLabels.fatura_iptal:cLabels.siparis_iptal}</span>
        <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => props.onCloseSidebar()} />
      </div>
    );
  };
  return (
    <Panel headerTemplate={template} toggleable>
      <BlockUI blocked={blocked} fullScreen />
      <form id="siparis-iptal-form" onSubmit={formik.handleSubmit}>
        <div className="grid">
          <div className="col-12">
            <div className="card">
              <div className="p-fluid p-formgrid grid">
                <div className="p-field col-12 lg:col-6 md:col-6 sm:col-12">
                  <label>{cLabels.f_ip_neden_type}</label>
                  <LkDropDown options={dd_sys_fat_iptal} id="f_ip_neden_type" fieldLabel="f_ip_neden" autoFocus formik={formik} />
                </div>
                <div className="p-field col-12">
                  <label>{cLabels.aciklama}</label>
                  <LkInputTextarea type="text" rows="2" id="f_ip_aciklama" formik={formik} />
                </div>

              </div>
            </div>
          </div>

        </div>
      </form>
      <div className="col-12 clear ">
        <Toolbar
          className="layout-topbar-search"
          icon="pi pi-check"
          left={<Button label={cLabels.iptal_et} type="submit" form="siparis-iptal-form" icon="pi pi-check" className="p-button-success p-mr-2" />}
        />
      </div>
    </Panel>
  );
};
